module.exports = __webpack_public_path__ + "img/cortinas_de_seguridad.a812f673.jpg";